<script>
import {
  layoutComputed
} from "@/state/helpers";
import {
  SimpleBar
} from "simplebar-vue3";
import { fetchMenus } from "@/helpers/menuApi.js"
export default {
  components: {
    SimpleBar
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      },
      // menus: ,
      // Horizontal layout: how many top menus fit on the bar (the rest under "More");
      // null: all of them.
      visibleCount: null,
      fitTimer: null,
    };
  },
  computed: {
    ...layoutComputed,
    layoutType: {
      get() {
        return this.$store ? this.$store.state.layout.layoutType : {} || {};
      },
    },
    menus() {
      const raw = this.$store.state.menus;
      if (!raw || !Array.isArray(raw)) return [];
      const cloned = JSON.parse(JSON.stringify(raw));
      const gov = cloned.find(m => m.menu_name === 'Government Compliance');
      if (gov) {
        if (!gov.children) {
          gov.children = [];
        }
        const hasTaxFiling = gov.children.some(c => c.menu_name === 'Tax Filing');
        if (!hasTaxFiling) {
          gov.children.push({
            menu_id: 99990,
            menu_name: 'Tax Filing',
            icon: 'ri-file-list-3-line',
            url: null,
            subchildren: [
              { menu_id: 99991, menu_name: 'Calendar', url: '/government-compliance/tax-filing/calendar', subchildren: [], grandchildren: [] },
              { menu_id: 99992, menu_name: 'Monthly', url: '/government-compliance/tax-filing/monthly', subchildren: [], grandchildren: [] },
              { menu_id: 99993, menu_name: 'Quarterly', url: '/government-compliance/tax-filing/quarterly', subchildren: [], grandchildren: [] },
              { menu_id: 99994, menu_name: 'Annual', url: '/government-compliance/tax-filing/annual', subchildren: [], grandchildren: [] },
            ],
            grandchildren: [],
          });
        }
      }
      const dash = cloned.find(m => m.menu_name === 'Dashboard');
      if (dash) {
        if (!dash.children) {
          dash.children = [];
        }
        const hasFlowChart = dash.children.some(c => c.menu_name === 'Flow Chart' || c.url === '/dashboard/flow-chart');
        if (!hasFlowChart) {
          const flowChartItem = {
            menu_id: 99995,
            menu_name: 'Flow Chart',
            icon: 'ri-flow-chart',
            url: '/dashboard/flow-chart',
            subchildren: [],
            grandchildren: [],
          };
          const prodIndex = dash.children.findIndex(c => c.menu_name && c.menu_name.toLowerCase().includes('production'));
          if (prodIndex !== -1) {
            dash.children.splice(prodIndex + 1, 0, flowChartItem);
          } else {
            dash.children.push(flowChartItem);
          }
        }
        if (dash.child && Array.isArray(dash.child)) {
          const hasInChild = dash.child.some(c => c.menu_name === 'Flow Chart' || c.url === '/dashboard/flow-chart');
          if (!hasInChild) {
            const flowChartItem = {
              menu_id: 99995,
              menu_name: 'Flow Chart',
              icon: 'ri-flow-chart',
              url: '/dashboard/flow-chart',
              subchildren: [],
              grandchildren: [],
            };
            const prodIndex = dash.child.findIndex(c => c.menu_name && c.menu_name.toLowerCase().includes('production'));
            if (prodIndex !== -1) {
              dash.child.splice(prodIndex + 1, 0, flowChartItem);
            } else {
              dash.child.push(flowChartItem);
            }
          }
        }
      }
      return cloned;
    },
    isHorizontal() {
      return this.layoutType === 'horizontal';
    },
    shownMenus() {
      return this.isHorizontal && this.visibleCount !== null ? this.menus.slice(0, this.visibleCount) : this.menus;
    },
    overflowMenus() {
      return this.isHorizontal && this.visibleCount !== null ? this.menus.slice(this.visibleCount) : [];
    },
  },
  watch: {
    menus() {
      this.fitHorizontal();
    },
    layoutType() {
      this.fitHorizontal();
    },
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * Horizontal layout: as many top menus as fit on one line of the bar; the rest go
     * under "More". Measured with all of them shown, then cut.
     */
    fitHorizontal() {
      clearTimeout(this.fitTimer);
      this.fitTimer = setTimeout(() => {
        if (!this.isHorizontal) {
          this.visibleCount = null;
          return;
        }
        this.visibleCount = null;
        this.$nextTick(() => {
          const nav = this.$el && this.$el.querySelector ? this.$el.querySelector('#navbar-nav') : null;
          if (!nav) return;
          const items = [...nav.children].filter(li => li.classList.contains('nav-item') && !li.classList.contains('menu-more'));
          const width = (el) => {
            const cs = getComputedStyle(el);
            return el.getBoundingClientRect().width + parseFloat(cs.marginLeft || 0) + parseFloat(cs.marginRight || 0);
          };
          const available = nav.clientWidth;
          const total = items.reduce((sum, li) => sum + width(li), 0);
          if (total <= available) return; // all fit
          const room = available - 110; // the "More" item
          let used = 0;
          let count = 0;
          for (const li of items) {
            used += width(li);
            if (used > room) break;
            count++;
          }
          this.visibleCount = Math.max(1, count);
        });
      }, 60);
    },
    onResize() {
      this.fitHorizontal();
    },
    // Compile-safe wrapper around $t for DYNAMIC keys (menu names from the API).
    // vue-i18n's message compiler throws SyntaxError when a key contains chars it
    // treats as syntax (e.g. unbalanced { }, |, @:). For dynamic strings we don't
    // want compilation — fall back to the raw value if anything goes wrong.
    safeT(key) {
      if (key == null) return '';
      try {
        if (typeof this.$te === 'function' && !this.$te(key)) return key;
        return this.$t(key);
      } catch (e) {
        return key;
      }
    },
    loadMenu() {
      const menuSplitVersion = localStorage.getItem('menu_split_v');
      const stored = localStorage.getItem('storedMenu');
      if (
        menuSplitVersion !== '6' ||
        stored == null || 
        stored.length === 0 || 
        !stored.includes('/maintenance/customers') || 
        !stored.includes('/maintenance/suppliers') || 
        !stored.includes('/maintenance/agents') || 
        !stored.includes('/cash-management/check-monitoring') ||
        !stored.includes('/cash-management/document-tagging') ||
        !stored.includes('Bank Statement Upload') ||
        !stored.includes('/government-compliance/cwt-monitoring') ||
        !stored.includes('/government-compliance/tax-filing/calendar')
      )
      {
        localStorage.setItem('menu_split_v', '6');
        fetchMenus();
      }
      else
      {
        this.$store.commit('getMenus');
      }
    },
    
    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0].offsetTop;
        if (currentPosition > 500)
          if (this.$refs.isSimplebar)
            this.$refs.isSimplebar.value.getScrollElement().scrollTop = currentPosition + 300;
      }
    },

    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#navbar-nav")) {
          let a = document.querySelector("#navbar-nav").querySelector('[href="' + ele + '"]');
          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add("active");
              parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
              if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
                parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
                if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
                  parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
                const grandparent = parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.parentElement.closest(".collapse");
                if (grandparent && grandparent && grandparent.previousElementSibling) {
                  grandparent.previousElementSibling.classList.add("active");
                  grandparent.classList.add("show");
                }
              }
            }
          }
        }
      }, 0);
    },
  },
  created() {
    
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
    clearTimeout(this.fitTimer);
  },
  mounted() {
    this.loadMenu();
    window.addEventListener('resize', this.onResize);
    this.fitHorizontal();
    if (document.querySelectorAll(".navbar-nav .collapse")) {
      let collapses = document.querySelectorAll(".navbar-nav .collapse");

      collapses.forEach((collapse) => {
        // Hide sibling collapses on `show.bs.collapse`
        collapse.addEventListener("show.bs.collapse", (e) => {
          e.stopPropagation();
          let closestCollapse = collapse.parentElement.closest(".collapse");
          if (closestCollapse) {
            let siblingCollapses =
              closestCollapse.querySelectorAll(".collapse");
            siblingCollapses.forEach((siblingCollapse) => {
              if (siblingCollapse.classList.contains("show")) {
                siblingCollapse.classList.remove("show");
                siblingCollapse.parentElement.firstChild.setAttribute("aria-expanded", "false");
              }
            });
          } else {
            let getSiblings = (elem) => {
              // Setup siblings array and get the first sibling
              let siblings = [];
              let sibling = elem.parentNode.firstChild;
              // Loop through each sibling and push to the array
              while (sibling) {
                if (sibling.nodeType === 1 && sibling !== elem) {
                  siblings.push(sibling);
                }
                sibling = sibling.nextSibling;
              }
              return siblings;
            };
            let siblings = getSiblings(collapse.parentElement);
            siblings.forEach((item) => {
              if (item.childNodes.length > 2) {
                item.firstElementChild.setAttribute("aria-expanded", "false");
                item.firstElementChild.classList.remove("active");
              }
              let ids = item.querySelectorAll("*[id]");
              ids.forEach((item1) => {
                item1.classList.remove("show");
                item1.parentElement.firstChild.setAttribute("aria-expanded", "false");
                item1.parentElement.firstChild.classList.remove("active");
                if (item1.childNodes.length > 2) {
                  let val = item1.querySelectorAll("ul li a");

                  val.forEach((subitem) => {
                    if (subitem.hasAttribute("aria-expanded"))
                      subitem.setAttribute("aria-expanded", "false");
                  });
                }
              });
            });
          }
        });

        // Hide nested collapses on `hide.bs.collapse`
        collapse.addEventListener("hide.bs.collapse", (e) => {
          e.stopPropagation();
          let childCollapses = collapse.querySelectorAll(".collapse");
          childCollapses.forEach((childCollapse) => {
            let childCollapseInstance = childCollapse;
            childCollapseInstance.classList.remove("show");
            childCollapseInstance.parentElement.firstChild.setAttribute("aria-expanded", "false");
          });
        });
      });
    }
  },

 
};
</script>

<template>
  <b-container fluid>
    <div id="two-column-menu"></div>

    <template v-if="layoutType === 'twocolumn'">
      <SimpleBar class="navbar-nav" id="navbar-nav">
        <li class="menu-title">
          <span data-key="t-menu"> {{ $t("t-menu") }}</span>
        </li>
        <li class="nav-item" v-for="(menu, index) in menus" :key="index">
          <b-link v-if="menu.child" class="nav-link menu-link" :href="'#menu'+index" data-bs-toggle="collapse" role="button"
            aria-expanded="false">
            <i v-if="menu.parent.icon" :class="menu.parent.icon"></i>
            <span> {{ safeT(menu.parent.name) }}</span>
          </b-link>
          <div v-if="menu.child" class="collapse menu-dropdown" :id="'menu'+index">
            <ul class="nav nav-sm flex-column">
              <li class="nav-item" v-for="(child, i) in menu.child" :key="i">
                <router-link :to="child.url" class="nav-link custom-abc">
                  {{ safeT(child.menu_name) }}
                </router-link>
              </li>
            </ul>
          </div>
          <div v-else>
            <router-link v-if="menu.parent.url" :to="menu.parent.url" class="nav-link custom-abc">
              <i v-if="menu.parent.icon" :class="menu.parent.icon"></i>
              <span> {{ safeT(menu.parent.name) }}</span>
            </router-link>
            <router-link v-else href="javascript: void(0)" class="nav-link custom-abc">
              <i v-if="menu.parent.icon" :class="menu.parent.icon"></i>
              <span> {{ safeT(menu.parent.menu_name) }}</span>
            </router-link>
          </div>
        </li>
      </SimpleBar>
    </template>

    <template v-else>
      <ul class="navbar-nav h-100" id="navbar-nav">
        <li class="menu-title">
          <span data-key="t-menu"> {{ $t("t-menu") }}</span>
        </li>

        <template v-for="(menu, index) in shownMenus" :key="index">

          <li v-if="menu.children.length == 0" class="nav-item">
            <router-link v-if="menu.url" :to="menu.url" class="nav-link" :data-key="menu.menu_name">
              <i v-if="menu.icon" :class="menu.icon"></i>
              <span :data-key="menu.menu_name"> {{ safeT(menu.menu_name) }}</span>
            </router-link>
          </li>
 
          <li v-else class="nav-item">
            <b-link 
              class="nav-link menu-link" 
              :href="'#menu'+index" 
              data-bs-toggle="collapse" 
              role="button"
              aria-expanded="false" 
              :aria-controls="'menu'+index">
  
              <i v-if="menu.icon" :class="menu.icon"></i>
              <span :data-key="menu.menu_name"> {{ safeT(menu.menu_name) }}</span>
            </b-link>

            <div class="collapse menu-dropdown" :id="'menu'+index">
              <ul class="nav nav-sm flex-column">

                <template v-for="(child, child_index) in menu.children" :key="child_index">

                  <li v-if="child.subchildren.length == 0" class="nav-item">
                    <router-link v-if="child.url" :to="child.url" class="nav-link" :data-key="child.menu_name">
                      {{ safeT(child.menu_name) }}
                    </router-link>
                  </li>
                
                  <li v-else class="nav-item">
                    <b-link :href="'#child'+index+'-'+child_index" class="nav-link" data-bs-toggle="collapse" role="button"
                      aria-expanded="false" :aria-controls="'child'+index+'-'+child_index" :data-key="child.menu_name">
                      {{ safeT(child.menu_name) }}
                    </b-link>

                    <div class="collapse menu-dropdown" :id="'child'+index+'-'+child_index">
                      <ul class="nav nav-sm flex-column">

                        <template v-for="(sub_child, sub_child_index) in child.subchildren" :key="sub_child_index">

                          <li v-if="sub_child.grandchildren.length == 0" class="nav-item">
                            <router-link v-if="sub_child.url" :to="sub_child.url" class="nav-link" :data-key="sub_child.menu_name">
                              {{ safeT(sub_child.menu_name) }}
                            </router-link>
                          </li>

                          <li v-else class="nav-item">
                            <b-link :href="'#sub_child'+index+'-'+child_index+'-'+sub_child_index" class="nav-link" data-bs-toggle="collapse" role="button"
                              aria-expanded="false" :aria-controls="'sub_child'+index+'-'+child_index+'-'+sub_child_index" :data-key="sub_child.menu_name">
                              {{ safeT(sub_child.menu_name) }}
                            </b-link>
                            <div class="collapse menu-dropdown" :id="'sub_child'+index+'-'+child_index+'-'+sub_child_index">
                              <ul class="nav nav-sm flex-column">
                          
                                <li class="nav-item" v-for="(grand_child, grand_child_index) in sub_child.grandchildren" :key="grand_child_index">
                                  <router-link v-if="grand_child.url" :to="grand_child.url" class="nav-link" :data-key="grand_child.menu_name">
                                    {{ safeT(grand_child.menu_name) }}
                                  </router-link>
                                </li>

                              </ul>
                            </div>
                          </li>

                        </template>

                      </ul>
                    </div>
                  </li>

                </template> 

              </ul>
            </div>
          </li>

        </template> 

        <!-- Horizontal layout: the menus that don't fit on the bar. -->
        <li v-if="overflowMenus.length" class="nav-item menu-more">
          <b-link class="nav-link menu-link" href="#menuMore" data-bs-toggle="collapse" role="button" aria-expanded="false" aria-controls="menuMore">
            <i class="ri-more-fill"></i>
            <span>More</span>
          </b-link>
          <div class="collapse menu-dropdown" id="menuMore">
            <ul class="nav nav-sm flex-column">
              <li v-for="(menu, m) in overflowMenus" :key="'more' + m" class="nav-item">
                <router-link v-if="!menu.children.length && menu.url" :to="menu.url" class="nav-link">{{ safeT(menu.menu_name) }}</router-link>
                <template v-else-if="menu.children.length">
                  <b-link :href="'#more' + m" class="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" :aria-controls="'more' + m">
                    {{ safeT(menu.menu_name) }}
                  </b-link>
                  <div class="collapse menu-dropdown" :id="'more' + m">
                    <ul class="nav nav-sm flex-column">
                      <li v-for="(child, c) in menu.children" :key="c" class="nav-item">
                        <router-link v-if="!child.subchildren.length && child.url" :to="child.url" class="nav-link">{{ safeT(child.menu_name) }}</router-link>
                        <template v-else-if="child.subchildren.length">
                          <b-link :href="'#more' + m + '-' + c" class="nav-link" data-bs-toggle="collapse" role="button" aria-expanded="false" :aria-controls="'more' + m + '-' + c">
                            {{ safeT(child.menu_name) }}
                          </b-link>
                          <div class="collapse menu-dropdown" :id="'more' + m + '-' + c">
                            <ul class="nav nav-sm flex-column">
                              <template v-for="(sub, sc) in child.subchildren" :key="sc">
                                <li v-if="sub.url" class="nav-item">
                                  <router-link :to="sub.url" class="nav-link">{{ safeT(sub.menu_name) }}</router-link>
                                </li>
                                <li v-for="(grand, g) in (sub.grandchildren || [])" :key="sc + '-' + g" class="nav-item">
                                  <router-link v-if="grand.url" :to="grand.url" class="nav-link ps-4">{{ safeT(grand.menu_name) }}</router-link>
                                </li>
                              </template>
                            </ul>
                          </div>
                        </template>
                      </li>
                    </ul>
                  </div>
                </template>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </template>
</b-container>
</template>